import React,{createContext,useContext} from 'react';
import './collection-surface.css';

const CollectionSurfaceContext=createContext(null);
const classes=(...values)=>values.filter(Boolean).join(' ');

/** One collection boundary: navigation, identity, query controls and records. */
export function CollectionSurface({navigation,controls,summary,children,label='Koleksiyon',className='',...props}){
 return <CollectionSurfaceContext.Provider value={{controls,summary}}><section aria-label={label} className={classes('bs-collection-surface',className)} {...props}>{navigation&&<div className="bs-collection-surface-navigation">{navigation}</div>}{children}</section></CollectionSurfaceContext.Provider>;
}

/** Shared by embedded tables and views without a table; controls render once. */
export function CollectionHeader({title,context,count,countLabel='kayıt',action}){
 const surface=useContext(CollectionSurfaceContext);
 const summary=surface?.summary??(count!=null?<span className="bs-project-table-count">{count} {countLabel}</span>:null);
 return <header className="bs-collection-header"><div className="bs-collection-header-heading"><div className="bs-collection-header-identity"><h2 className="bs-collection-header-title">{title}</h2>{context&&<span className="bs-collection-header-context">{context}</span>}</div>{summary&&<div className="bs-collection-header-summary">{summary}</div>}</div>{(surface?.controls||action)&&<div className="bs-collection-header-tools">{surface?.controls}{action&&<div className="bs-collection-header-action">{action}</div>}</div>}</header>;
}

export function useCollectionSurface(){return useContext(CollectionSurfaceContext);}
